module.exports = __webpack_public_path__ + "img/campaign-completed-icon.657ab4f2.png";